import { IonCard } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { State } from '../../store'
import {
  addMessage,
  addMessageType,
  nextMessage,
  nextMessageType,
  PeterMessage
} from '../../store/peter'

interface StateProps {
  expanded: boolean

  messages: PeterMessage[]
}

interface DispatchProps {
  addMessage: addMessageType
  nextMessage: nextMessageType
}

type Props = StateProps & DispatchProps

const Message = styled(IonCard)`
  position: fixed;
  bottom: 132px;
  right: 32px;
  padding: 16px;
`

const Button = styled.div`
  z-index: 10000;
  position: fixed;
  bottom: 48px;
  right: 8px;
  width: 100px;
  
  img {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  
  .circle {    
    z-index: -1;
    position: absolute;
    bottom: 12px;
    right: 12px;
    background: #000;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    
    .inner {
      position: absolute;
      width: 76px;
      height: 76px;
      background: #FFF;
      bottom: 2px;
      right: 2px;
      border-radius: 50%;
    }
  }
`

const Internal: React.FC<Props> = (props) => {
  const [message, setMessage] = useState<PeterMessage>()

  const animationDurations: {[key: string]: number} = {
    greet: 5000,
    convince: 5000,
    pointLeft: 5000,
  }

  useEffect(() => {
    if (!message) return

    const t = setTimeout(() => {
      props.nextMessage()
      setMessage(undefined)
    }, animationDurations[message.animation] || 100)

    // TODO check how long to show text!

    return () => {
      clearTimeout(t)
    }
  }, [message])

  useEffect(() => {
    if (props.messages.length > 0) {
      setMessage(props.messages[0])
    }
  }, [props.messages])

  return (
    <>
      {message?.message && (
        <Message>
          {message?.message}
        </Message>
      )}
      <Button>
        <img src={require('./images/base.png')} />
        <img src={require('./images/greet.gif')} style={{ display: message?.animation === 'greet' ? undefined : 'none'}} onLoad={() => props.addMessage({
          animation: 'greet',
          message: 'Willkommen, ich bin Peter'
        })} />
        <img src={require('./images/convince.gif')} style={{ display: message?.animation === 'convince' ? undefined : 'none'}} />
        <img src={require('./images/point-left.gif')} style={{ display: message?.animation === 'pointLeft' ? undefined : 'none'}} />
        <div className={'circle'}>
          <div className={'inner'} />
        </div>
      </Button>
    </>
  )
}

const Peter = connect<StateProps, DispatchProps, unknown, State>(({ peter }) => ({
  expanded: peter.expanded,
  messages: peter.messages
}), {
  addMessage,
  nextMessage,
})(Internal)

export default Peter
